import Vue from 'vue'
import VueI18n from 'vue-i18n'
import th from '@/language/th'
import la from '@/language/la'
import en from '@/language/en'
import { getLocale, setLocale, setCookieI18n } from '@/utils/locale'
const messages = {
  th: th,
  la: la,
  en: en
}
Vue.use(VueI18n)
const localeLang = process.env.VUE_APP_LAOS === 'true' ? 'la' : 'th'
const lang = getLocale() ? getLocale() : localeLang
setLocale(lang)
setCookieI18n(lang.toUpperCase())
const i18n = new VueI18n({
  locale: lang,
  messages
})
export default i18n
